import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

const baseIdPrefix = 'life-insurance-faq-modified-endowments';
const baseIdSuffix = 'faq';

export default () => (
  <SectionContainer id={`${baseIdPrefix}-${baseIdSuffix}`}>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          align='center'>
          Learn About Modified Endowments &#40;MEC&#39;s&#41;
        </Typography>
        <Accordion
          id='faq-modified-endowments-faq'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          addFAQPageSchemaItemType={false}
          items={[
            {
              id: `${baseIdPrefix}-contract-what-is-${baseIdSuffix}`,
              title:<>What is a Modified Endowment Contract &#40;MEC&#41;&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    The primary purpose of life insurance has always been to help solve the financial needs
                    caused by premature death. Because of its social value, the law has historically given preferential tax treatment to life insurance&#8212;cash value grows tax deferred, lifetime distributions are treated as a nontaxable return of basis first and then as taxable gain, loans are not taxed when taken and death proceeds are generally received income tax free to the beneficiary.
                  </Typography>
                  <Typography nextElement='typography'>
                    An MEC is a heavily funded life insurance policy which is taxed as an annuity in certain situations. A MEC does not receive all of the tax preferences of life insurance.
                  </Typography>
                  <Typography disableBottomPadding>
                    As with whole life insurance, the cash value build up of a MEC is tax deferred and the death benefit is income tax free. However, any loans or withdrawals from a MEC will be taxed at the time of withdrawal to the extent of the gain in the policy and may also be subject to a 10&#37; penalty tax.
                  </Typography>
                </>
              ),
            },
            {
              id: `${baseIdPrefix}-contract-should-i-purchase-${baseIdSuffix}`,
              title: <>Should I purchase a life insurance policy which is a Modified Endowment Contract&#63;</>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  That depends on the reasons you want to purchase the life insurance policy. If your primary
                  concern is to protect your beneficiaries from your premature death, the MEC status will probably have little effect. The two major tax advantages remain in place. The cash value will still grow tax deferred and your beneficiaries will still receive the death proceeds income tax free. In addition, payments received under a payment plan will still be taxed on a pro rata basis. However, if you plan to take lifetime distributions parentheses &#40;including loans parentheses&#41; from the policy, a MEC may not be appropriate.
                </Typography>
              ),
            },
            {
              id: `${baseIdPrefix}-tax-purposes-${baseIdSuffix}`,
              title: <>What constitutes a distribution for Modified Endowment Contract for tax purposes&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    Distributions that are taxable include: policy loans, premium loans  parentheses &#40;paid from the cash value parentheses&#41;, assignments as collateral for loans, annual dividends used to repay loans or loan interest, dividends received in cash, and partial and full surrenders of the policy for cash.
                  </Typography>
                  <Typography disableBottomPadding>
                    Distributions do not include dividends used to reduce premiums or purchase additional coverage and surrender of paid up additions to pay premiums.
                  </Typography>
                </>
              ),
            },
            {
              id: `${baseIdPrefix}-taxation-of-distributions-${baseIdSuffix}`,
              title: <>What is the difference between the taxation of distributions from non Modified Endowment life insurance policies and distributions from Modified Endowment Contracts&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    Distributions from the non MEC life insurance policies are taxed basis first, gain second,
                    while distributions from a MEC are taxed gain first, basis second. The order in which basis is withdrawn is important because basis is not taxable. The following example illustrates the
                    difference.
                  </Typography>
                  <Typography disableBottomPadding>
                    Assume a policy has a cash value of &#36;10,000 composed of &#36;4,000 of nontaxable basis and &#36;6,000 of taxable gain and a &#36;7,000 distribution is taken. Because a non MEC life insurance policy is taxed basis first, gain second, only &#36;3,000 of the distribution &#40;	&#36;7,000&#8212;	&#36;4,000 &#40;basis&#41;&#41; would be taxed if the policy is not a MEC. However, because a MEC is taxed gain first, basis second, &#36;6,000 of the distribution &#40;the entire gain&#41; would be taxed if the policy were a MEC. An additional 10&#37; penalty tax could also apply to the &#36;6,000 of taxable gain, if the policyowner was under age 59&#189;.
                  </Typography>
                </>
              ),
            },
            {
              id: `${baseIdPrefix}-become-disabled-${baseIdSuffix}`,
              title: <>What happens if I become disabled and need to use the cash value of my Modified Endowment
                Contract&#63;</>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  You'll pay income tax on the gain. However, you will not be charged the 10&#37; penalty tax on amounts taken out during your disability if you meet the tax law definition of disability.
                </Typography>
              ),
            },
            {
              id: `${baseIdPrefix}-college-tuition-cash-value-${baseIdSuffix}`,
              title: <>I may need part of the cash value for my children&#39;s college tuition or for emergencies. Should I avoid a Modified Endowment Contract&#63;</>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  If, as the owner of the contract, you will need to withdraw part of the cash value before
                  you are 59&#189;, you should avoid a Modified Endowment Contract. You will be taxed on any withdrawals to the extent of the gain in the contract and you will be charged an additional 10&#37; penalty tax on the taxable portion of any withdrawal.
                </Typography>
              ),
            },
            {
              id: `${baseIdPrefix}-how-to-determine-${baseIdSuffix}`,
              title: <>How do you determine if a policy is a Modified Endowment Contract&#63;</>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  The tax law has established a &#34;7 pay test&#34; which limits the amount of premiums
                  that can be paid for a specified amount of life insurance coverage. If this limit is exceeded, the  policy will be classified as a MEC. Prior to issuance, the 7 pay test is applied to determine if the policy, as applied for, will be classified as a MEC at issue or at any time in the future.
                </Typography>
              ),
            },
            {
              id: `${baseIdPrefix}-traditional-policy-become-${baseIdSuffix}`,
              title: <>Can a traditional life insurance policy become a Modified Endowment Contract&#63;</>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Yes. A change to a traditional life policy which results in either an increase in premiums,
                  or an increase or reduction in the insurance coverage, may cause the policy to fail the 7 pay test or to be retested for MEC status. For example, if within the first 7 years a policy is partially surrendered or lapses to a reduced amount of paid&#45;up insurance, &#40;and is not reinstated within 90 days&#41;, the test is applied to determine if premiums paid have exceeded the limit for the reduced coverage. If it has, the policy is reclassified as a MEC.
                </Typography>
              ),
            },
            {
              id: `${baseIdPrefix}-prevent-policy-${baseIdSuffix}`,
              title: <>How can I prevent my policy from becoming a Modified Endowment Contract&#63;</>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    If testing shows that your policy will be classified as a MEC, you will be notified and
                    given the opportunity to make changes to avoid MEc status.
                  </Typography>
                  <Typography nextElement='typography'>
                    Check with your Northwestern Mutual Financial Representative to see if the best option for you is to pay a lower premium and maintain your coverage, or to maintain your premium and increase your insurance coverage. To reverse MEC status caused by a premium payment in excess of the pay limit, the excess premium must be withdrawn with interest within 60 days of the following policy anniversary. To reverse the MEC status caused by a lapse, the policy must be reinstated within 90 days of the date the premium is paid to at lapse. The choice you make should depend on your need for life insurance coverage.
                  </Typography>
                  <Typography disableBottomPadding>
                    However, once the cure periods have expired, it may not be possible to undo the MEC status.
                  </Typography>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
